







































































































import Vue, { PropType } from "vue";
import { mapGetters } from "vuex";

// Model
import { InstallationSmartLockStatus } from "@/model/data/oneTimeCode/InstallationSmartLockStatus";
import { ActivateSmartLockCommand } from "@/model/communication/oneTimeCode/ActivateSmartLockCommand";
import { ActivateSmartLockResData } from "@/model/communication/oneTimeCode/ActivateSmartLockResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { Machine } from "@/model/data/Machine";
import { SmartLockInternalState } from "@/model/data/enums/SmartLockInternalStateEnum";
import { CReqExecutionResultEnum } from "@/model/communication/CReqExecutionResultEnum";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default Vue.extend({
    props: {
        installation: Object as PropType<InstallationSmartLockStatus>,
        machine: Object as PropType<Machine>,
    },
    data() {
        return {
            smartLockModes: [
                { value: 0, text: this.$t("smartLock.closingCode") },
                { value: 1, text: this.$t("smartLock.openingCode") },
            ],
            smartLockMode: null,
            codeValidityModel: 15,
            openLockSessionDurationModel: 60,
            onlyIntegerValidator: [(v) => /^\d+$/.test(v) || this.$t("security_management.onlyInteger"), (v) => v > 0 || this.$t("smartLock.codeValidityRequired")],
            onlyNumber: [(v) => /^\d+$/.test(v) || this.$t("smartLock.onlyNumber"), (v) => /^\d{8}$/.test(v) || this.$t("smartLock.8digit")],
            acceptDisclaimer: false,
            activateLoading: false,
            localInstallation: null,
            SmartLockInternalState,
            showAlert: false,
            alertMessage: "",
            alertType: "",
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        canActivate() {
            if (!this.acceptDisclaimer) return false;
            if (!this.smartLockModes.map((s) => s.value).includes(this.smartLockMode)) return false;
            if (this.smartLockMode == 1 && (this.codeValidityModel < 1 || !/^\d+$/.test(this.codeValidityModel))) return false;
            if (this.openLockSessionDurationModel < 1 || !/^\d+$/.test(this.openLockSessionDurationModel)) return false;
            return true;
        },
        machineSmartLock() {
            if (this.localInstallation && this.localInstallation.smartLocks && this.localInstallation.smartLocks.get(this.machine.serialNumber))
                return this.localInstallation.smartLocks.get(this.machine.serialNumber);
            return null;
        },
        hasActivationPrivilege() {
            return this.authUserHasPrivilege(ClientPrivileges.SmartLockActivation);
        },
    },
    watch: {
        installation: {
            handler(newVal) {
                this.localInstallation = newVal;
                this.reset();
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        reset() {
            this.showAlert = false;
            this.alertMessage = "";
            this.alertType = "";
        },
        activate() {
            if (this.canActivate) {
                this.sendActivateRequest(this.machine.serialNumber);
            }
        },
        async sendActivateRequest(machineSerialNumber: string) {
            try {
                this.activateLoading = true;
                this.showAlert = false;
                let response: ActivateSmartLockResData = await new ActivateSmartLockCommand(
                    this.installation.name,
                    machineSerialNumber,
                    this.smartLockMode,
                    this.openLockSessionDurationModel,
                    this.codeValidityModel
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success && response.installation && response.installation.smartLocks) {
                    this.$emit("activated", response.installation);
                    if (this.machineSmartLock.internalState != SmartLockInternalState.FieldActive) {
                        this.showAlert = true;
                        this.alertMessage = this.$t("smartLock.genericErrorActivating");
                        this.alertType = "error";
                    } else {
                        this.showAlert = true;
                        this.alertMessage = this.$t("smartLock.activateSuccessfull");
                        this.alertType = "success";
                    }
                } else {
                    throw response.message;
                }
            } catch (error) {
                switch (error) {
                    case CReqExecutionResultEnum.AgentOffline:
                        this.alertMessage = this.$t("smartLock.agentOfflineForInstallation");
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.AgentNotInstalled:
                        this.alertMessage = this.$t("smartLock.agentNotInstalled");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.DeviceLocked:
                        this.alertMessage = this.$t("smartLock.agentLocked");
                        this.alertType = "warning";
                        break;
                    case CReqExecutionResultEnum.OperationNotAvailable:
                        this.alertMessage = this.$t("smartLock.operationNotAvailable");
                        this.alertType = "info";
                        break;
                    case CReqExecutionResultEnum.ServerError:
                        this.alertMessage = this.$t("smartLock.genericErrorActivating");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.InvalidRequest:
                        this.alertMessage = this.$t("smartLock.invalidVersion");
                        this.alertType = "error";
                        break;
                    case CReqExecutionResultEnum.FileNotFound:
                        this.alertMessage = this.$t("smartLock.smartLockNotFound");
                        this.alertType = "error";
                        break;
                    default:
                        console.error("Something went wrong sending ActivateSmartLock request ", error);
                        this.alertMessage = this.$t("smartLock.genericErrorActivating");
                        this.alertType = "error";
                        break;
                }
                this.showAlert = true;
            }
            this.activateLoading = false;
        },
    },
});
